module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc24-a41274b4821d75c70f4517382801c9a4.jpg";